import type { SeoIssueListParams } from '../api/seo-api';

/** Store-scoped keys: resolving an issue or queueing an audit invalidates everything under `all`. */
export const seoKeys = {
  all: (storeId: string) => ['stores', storeId, 'seo'] as const,
  issues: (storeId: string) => [...seoKeys.all(storeId), 'issues'] as const,
  issueList: (storeId: string, params: SeoIssueListParams) =>
    [...seoKeys.issues(storeId), params] as const,
  audits: (storeId: string) => [...seoKeys.all(storeId), 'audits'] as const,
};
